export default __webpack_public_path__ + "static/media/item-2.0ca32da8.webp";